export default "__VITE_ASSET__d4dd4591__"